var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('p',[_vm._v("이메일 문의 : sajupick@kakao.com")]),_c('p',[_vm._v("테스트 운영 중입니다.")])])}]

export { render, staticRenderFns }